import React from 'react';

const TestimonialOne = () => {
  return (
    <section className="testimonial-one">
      <div className="testimonial-one__bg-shape" style={{ backgroundImage: 'url(assets/images/shapes/testimonial-one-bg-shape.png)' }}></div>
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6">
            <div className="testimonial-one__left">
              <div className="section-title text-left sec-title-animation animation-style2">
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">Stories of Impact</span>
                </div>
                <h2 className="section-title__title title-animation">What people say about<br /> <span>Rayyan Aid</span></h2>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="testimonial-one__right">
              <div className="testimonial-one__thumb-outer-box">
                <div className="testimonial-one__thumb-carousel owl-carousel owl-theme">
                  <div className="testimonial-one__thumb-item">
                    <div className="testimonial-one__img-holder-box testimonial-one__img-holder-box-1">
                      <div className="testimonial-one__img-holder">
                        <img src="assets/images/user1.webp" alt="Donor portrait" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-one__thumb-item">
                    <div className="testimonial-one__img-holder-box">
                      <div className="testimonial-one__img-holder testimonial-one__img-holder-2">
                        <img src="assets/images/user2.webp" alt="Volunteer portrait" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-one__thumb-item">
                    <div className="testimonial-one__img-holder-box">
                      <div className="testimonial-one__img-holder testimonial-one__img-holder-3">
                        <img src="assets/images/user3.jpg" alt="Beneficiary portrait" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-one__thumb-item">
                    <div className="testimonial-one__img-holder-box">
                      <div className="testimonial-one__img-holder testimonial-one__img-holder-4">
                        <img src="assets/images/user4.jpg" alt="Partner portrait" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="testimonial-one__main-content">
                <div className="testimonial-one__carousel owl-carousel owl-theme">
                  <div className="item">
                    <div className="testimonial-one__single">
                      <div className="testimonial-one__ratting">
                        <span className="icon-star"></span>
                        <span className="icon-star"></span>
                        <span className="icon-star"></span>
                        <span className="icon-star"></span>
                        <span className="last-star icon-star"></span>
                      </div>
                      <p className="testimonial-one__text">Rayyan Aid’s school meals program kept my children in class and focused. Their support arrived quickly and with dignity.</p>
                      <div className="testimonial-one__client-info">
                        <div className="testimonial-one__client-img">
                          <img src="assets/images/user1.webp" alt="Amina – Parent" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                        </div>
                        <div className="testimonial-one__client-content">
                          <h3><a href="#">Aminu Bello</a></h3>
                          <p>Parent, Kano</p>
                        </div>
                      </div>
                      <div className="testimonial-one__quote"><span className="icon-quote"></span></div>
                    </div>
                  </div>

                  <div className="item">
                    <div className="testimonial-one__single testimonial-one__single-2">
                      <div className="testimonial-one__ratting">
                        <span className="icon-star"></span>
                        <span className="icon-star"></span>
                        <span className="icon-star"></span>
                        <span className="icon-star"></span>
                        <span className="last-star icon-star"></span>
                      </div>
                      <p className="testimonial-one__text">Volunteering with Rayyan Aid has been life‑changing. The team is organized, transparent and focused on real impact.</p>
                      <div className="testimonial-one__client-info">
                        <div className="testimonial-one__client-img">
                          <img src="assets/images/user2.webp" alt="Musa – Volunteer" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                        </div>
                        <div className="testimonial-one__client-content">
                          <h3><a href="#">Musa Abdullahi</a></h3>
                          <p>Volunteer, Lagos</p>
                        </div>
                      </div>
                      <div className="testimonial-one__quote"><span className="icon-quote"></span></div>
                    </div>
                  </div>

                  <div className="item">
                    <div className="testimonial-one__single testimonial-one__single-3">
                      <div className="testimonial-one__ratting">
                        <span className="icon-star"></span>
                        <span className="icon-star"></span>
                        <span className="icon-star"></span>
                        <span className="icon-star"></span>
                        <span className="last-star icon-star"></span>
                      </div>
                      <p className="testimonial-one__text">As a partner, I trust Rayyan Aid’s transparent reporting and community‑led approach. Funds reach the people who need them.</p>
                      <div className="testimonial-one__client-info">
                        <div className="testimonial-one__client-img">
                          <img src="assets/images/user3.jpg" alt="Fatima – Partner" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                        </div>
                        <div className="testimonial-one__client-content">
                          <h3><a href="#">Uzairu Abubakar</a></h3>
                          <p>Program Partner</p>
                        </div>
                      </div>
                      <div className="testimonial-one__quote"><span className="icon-quote"></span></div>
                    </div>
                  </div>

                  <div className="item">
                    <div className="testimonial-one__single testimonial-one__single-4">
                      <div className="testimonial-one__ratting">
                        <span className="icon-star"></span>
                        <span className="icon-star"></span>
                        <span className="icon-star"></span>
                        <span className="icon-star"></span>
                        <span className="last-star icon-star"></span>
                      </div>
                      <p className="testimonial-one__text">Our donation provided clean water to a village within weeks. Rayyan Aid kept us updated every step of the way.</p>
                      <div className="testimonial-one__client-info">
                        <div className="testimonial-one__client-img">
                          <img src="assets/images/user4.jpg" alt="Abdullahi – Donor" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                        </div>
                        <div className="testimonial-one__client-content">
                          <h3><a href="#">Abdullahi Umar</a></h3>
                          <p>Donor</p>
                        </div>
                      </div>
                      <div className="testimonial-one__quote"><span className="icon-quote"></span></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialOne;
